import TransferReview from 'components/transferReview';
import React from 'react';

function ReviewPage() {
  return (
    <div className="rightContent">
      <TransferReview />
    </div>
  );
}

export default ReviewPage;
